/** @format */

import React, { useEffect, useMemo, useState } from 'react'
import * as Styles from './style'
import { Link, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { jwtDecode } from 'jwt-decode'
import { changeDateTimeFormat } from '../shared/Helper'
import { usePagination, useTable, useSortBy } from 'react-table'
import editIcon from '../assets/images/edit.png'
import deleteIcon from '../assets/images/delete.png'
import ProjectForm from './components/ProjectForm/ProjectForm'
import { useDispatch, useSelector } from 'react-redux'
import { getAllProjects } from '../reduxLogic/reducers/projects/getAllProjectSlice'
import { getAllClusters } from '../reduxLogic/reducers/clusters/getAllClustersSlice'
import { getClusterByProject } from '../reduxLogic/reducers/clusters/getClusterByProjectSlice'
import EditProjectForm from './components/EditProjectForm/EditProjectForm'
import DeleteModal from './components/DeleteModal/DeleteModal'
import axios from 'axios'
import Cookies from 'universal-cookie'
const cookies = new Cookies()

const BeeMitraNameComponent = ({ id, index, isLast }) => {
  const [name, setName] = useState(`BeeMitra ${index + 1}`);

  useEffect(() => {
    const fetchName = async () => {
      try {
        const config = {
          headers: {
            Authorization: 'Bearer ' + cookies.get('access_token'),
            source: 'humblebee_admin',
          },
        };
        const res = await axios.get(
          `${process.env.REACT_APP_API_APP_USER_URL}/user/user-id-details/${id}`,
          config
        );
        if (res.data && res.data.user && res.data.user.name) {
          setName(res.data.user.name);
        }
      } catch (error) {
        console.error('Error fetching BeeMitra name:', error);
      }
    };
    if (id) {
      fetchName();
    }
  }, [id]);

  return (
    <span>
      <Link to={`/beemitras/${id}`}>{name}</Link>
      {!isLast ? ', ' : ''}
    </span>
  );
};
const Clusters = () => {
  var { projectId } = useParams()
  const userData = cookies.get('userData')

  const formatDate = date => {
    if (!date) return '-'
    const d = new Date(date)
    const day = String(d.getDate()).padStart(2, '0')
    const month = String(d.getMonth() + 1).padStart(2, '0') // getMonth() is zero-based
    const year = d.getFullYear()
    return `${day}-${month}-${year}`
  }

  const Project_TABLE_COLUMNS = [
    { Header: 'Cluster ID', accessor: 'clusterId' },
    { Header: 'Cluster', accessor: 'clusterName' },
    { Header: 'Project', accessor: 'projectId.name' },
    { Header: 'Number Of Trainee' },
    {
      Header: 'BeeMitra',
      accessor: 'beeMitras',
      Cell: ({ value }) => {
        if (!value || value.length === 0) {
          return 'No BeeMitra';
        } else {
          return value.map((beeMitra, index) => {
            const id = typeof beeMitra === 'object' ? beeMitra._id : beeMitra;
            return (
              <BeeMitraNameComponent 
                key={index} 
                id={id} 
                index={index} 
                isLast={index === value.length - 1} 
              />
            );
          });
        }
      }
    },    
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ value }) => {
        const isInactive = value === 'inactive';
        return (
          <span
            style={{
              backgroundColor: isInactive ? '#fff5f5' : '#e6fffa',
              color: isInactive ? '#d63031' : '#00b894',
              border: `1px solid ${isInactive ? '#ffa8a8' : '#b2f2bb'}`,
              padding: '4px 10px',
              borderRadius: '12px',
              fontWeight: '600',
              fontSize: '12px',
            }}
          >
            {isInactive ? '🔴 Inactive' : '🟢 Active'}
          </span>
        );
      },
    },
    {
      Header: 'State',
      accessor: 'state',
      Cell: ({ value }) => Array.isArray(value) ? (value.length > 0 ? value.join(', ') : '-') : (value || '-')
    },
    {
      Header: 'District',
      accessor: 'district',
      Cell: ({ value }) => Array.isArray(value) ? (value.length > 0 ? value.join(', ') : '-') : (value || '-')
    },
    {
      Header: 'Block',
      accessor: 'block',
      Cell: ({ value }) => Array.isArray(value) ? (value.length > 0 ? value.join(', ') : '-') : (value || '-')
    },
    {
      Header: 'Village',
      accessor: 'village',
      Cell: ({ value }) => Array.isArray(value) ? (value.length > 0 ? value.join(', ') : '-') : (value || '-')
    },
    {
      Header: 'Created On',
      accessor: 'createdOn',
      Cell: ({ value }) => formatDate(value),
    },
    { Header: 'Edit', accessor: '' },
  ]

  const [openModal, setOpenModal] = useState(false)
  const [singleRow, setSingleRow] = useState({})
  const [idToEdit, setIdToEdit] = useState('')
  const [openDeleteModal, setDeleteModal] = useState(false)
  const [idToDelete, setIdToDelete] = useState()
  const [clusterToDelete, setClusterToDelete] = useState(null)
  const [openEditModal, setOpenEditModal] = useState(false)
  const [traineesNo, settraineesNo] = useState(false)
  const [traineeCounts, setTraineeCounts] = useState({})
  const [searchTerm, setSearchTerm] = useState('')
  const currentToken = cookies.get('access_token') || localStorage.getItem('humblebeeAuthToken')
  let role = ''
  try {
    if (currentToken) {
      const decoded = jwtDecode(currentToken)
      role = decoded?.role || ''
    }
  } catch (e) {
    console.log('Error decoding token:', e)
  }

  const dispatch = useDispatch()

  const fetchAllProjectsData = () => {
    dispatch(getAllClusters())
  }

  const fetchClusterByProjectId = () => {
    dispatch(getClusterByProject(projectId))
  }

  useEffect(() => {
    if (projectId) {
      fetchClusterByProjectId()
    } else {
      fetchAllProjectsData()
    }
  }, [dispatch, projectId])

  const { clusterData } = useSelector(state => state.clusterData)
  const { clusterViaProjectData } = useSelector(
    state => state.clusterViaProjectData
  )

  const GetTrainees = async id => {
    try {
      const currentToken = cookies.get('access_token') || localStorage.getItem('humblebeeAuthToken')
      const config = {
        headers: {
          Authorization: 'Bearer ' + currentToken,
          source: 'HumblebeeWebApp',
        },
      }

      const res = await axios.get(
        `${process.env.REACT_APP_API_APP_FIELD_URL}/clusters/trainees/${id}`,
        config
      )

      return { id, trainees: res.data?.trainees || [] }
    } catch (error) {
      console.log('Error in getting Project data:', error)
      return { id, trainees: [] }
    }
  }
  const fetchDataForIds = async clusterData => {
    try {
      const results = await Promise.all(
        clusterData.map(c => GetTrainees(c._id))
      )
      const countsMap = {}
      results.forEach(item => {
        countsMap[item.id] = (item.trainees || []).length
      })
      setTraineeCounts(countsMap)
      const trainingsArray = results.map(result => result.trainees)
      settraineesNo(trainingsArray)
      console.log('Trainee counts map:', countsMap)
    } catch (error) {
      console.error('Error fetching data for clusterData:', error)
    }
  }

  useEffect(() => {
    if (projectId) {
      if (clusterViaProjectData?.length > 0) {
        console.log(clusterViaProjectData)
        fetchDataForIds(clusterViaProjectData)
      }
    } else {
      if (clusterData?.length > 0) {
        console.log(clusterData)
        fetchDataForIds(clusterData)
      }
    }
  }, [clusterData, clusterViaProjectData])

  const columns = useMemo(() => {
    const newColumns = [...Project_TABLE_COLUMNS]
    // newColumns[0] = {
    //   Header: "S.No",
    //   accessor: (_, index) => `P${index + 1}`,
    // };
    return newColumns
  }, [])

  const data = useMemo(() => {
    let list =
      clusterData.length > 0 && !projectId
        ? clusterData
        : clusterViaProjectData || []

    if (searchTerm && searchTerm.trim() !== '') {
      const q = searchTerm.trim().toLowerCase()
      list = list.filter(item => {
        const cId = (item.clusterId || '').toLowerCase()
        const cName = (item.clusterName || '').toLowerCase()
        const pName = (item.projectId?.name || '').toLowerCase()
        const dist = (Array.isArray(item.district) ? item.district.join(' ') : (item.district || '')).toLowerCase()
        const blk = (Array.isArray(item.block) ? item.block.join(' ') : (item.block || '')).toLowerCase()
        const vlg = (Array.isArray(item.village) ? item.village.join(' ') : (item.village || '')).toLowerCase()
        return cId.includes(q) || cName.includes(q) || pName.includes(q) || dist.includes(q) || blk.includes(q) || vlg.includes(q)
      })
    }

    return list
  }, [clusterData, clusterViaProjectData, projectId, searchTerm])

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 1000 },
    },
    useSortBy,
    usePagination
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    pageCount,
    gotoPage,
    state,
    setPageSize,
  } = tableInstance

  const { pageIndex, pageSize } = state

  const handleModalToggle = () => {
    setOpenModal(prev => !prev)
  }

  const handleOpenEditModal = (id, singleRow) => {
    console.log('singleRow', singleRow)
    setSingleRow(singleRow)
    setIdToEdit(id)
    setOpenEditModal(true)
  }

  const handleOpenDeleteModal = (id, rowData) => {
    const count = traineeCounts[id] || 0
    if (count > 0) {
      toast.warning(
        `Cannot delete cluster "${rowData?.clusterName || rowData?.clusterId}". It has ${count} assigned trainee(s). Please reassign them first!`
      )
      return
    }
    setClusterToDelete(rowData)
    setIdToDelete(id)
    setDeleteModal(true)
  }


  return (
    <Styles.SupplierBox>
      <Styles.SupplierTopSection>
      {userData.userType.name != 'Funder' ? (
        <div style={{ display: 'flex', gap: '15px', alignItems: 'center', justifyContent: 'space-between', width: '100%', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <Styles.ModalButton onClick={handleModalToggle}>
              Add Cluster
            </Styles.ModalButton>
            <Link to="/clusters/assign-trainees" style={{ textDecoration: 'none' }}>
              <button
                style={{
                  backgroundColor: '#2563EB',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '9px 16px',
                  fontSize: '13px',
                  fontWeight: '700',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  boxShadow: '0 2px 4px rgba(37, 99, 235, 0.2)',
                }}
              >
                ⚡ Bulk Assign Trainees
              </button>
            </Link>
          </div>

          {/* Quick Search */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="text"
              placeholder="Search by Cluster ID / Name..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              style={{
                padding: '8px 14px',
                border: '1px solid #d9d9d9',
                borderRadius: '6px',
                fontSize: '13px',
                width: '320px',
                outline: 'none',
                boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
              }}
            />
            {searchTerm && (
              <button
                onClick={() => setSearchTerm('')}
                style={{
                  border: 'none',
                  background: 'none',
                  cursor: 'pointer',
                  color: '#94a3b8',
                  fontSize: '14px',
                  fontWeight: 'bold',
                }}
              >
                ✕
              </button>
            )}
          </div>
        </div>
      ) : null}
        {openModal && (
          <ProjectForm openModal={openModal} setOpenModal={setOpenModal} />
        )}
      </Styles.SupplierTopSection>

      <Styles.TableContainer>
        {clusterData || clusterViaProjectData ? (
          <Styles.Table {...getTableProps()}>
            <Styles.THead>
              {headerGroups.map(headerGroup => (
                <Styles.THeadRow {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(headerColumn => (
                    <Styles.TH
                      {...headerColumn.getHeaderProps(
                        headerColumn.getSortByToggleProps()
                      )}
                    >
                      {headerColumn.render('Header')}
                      <span>
                        {headerColumn.isSorted
                          ? headerColumn.isSortedDesc
                            ? ' 🔼'
                            : ' 🔽'
                          : ''}
                      </span>
                    </Styles.TH>
                  ))}
                </Styles.THeadRow>
              ))}
            </Styles.THead>

            <Styles.TBody {...getTableBodyProps()}>
              {page.map((row, index) => {
                prepareRow(row)
                return (
                  <Styles.TBodyRow {...row.getRowProps()}>
                    {row.cells.map(cell => {
                      return (
                        <Styles.TD key={cell.column.id}>
                          {cell.column.Header === 'Edit' && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <button
                                disabled={userData?.userType?.name === 'Funder'}
                                onClick={() =>
                                  handleOpenEditModal(
                                    cell?.row?.original?._id,
                                    cell?.row.original
                                  )
                                }
                                title="Edit Cluster"
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  cursor: userData?.userType?.name === 'Funder' ? 'not-allowed' : 'pointer',
                                  padding: 0,
                                }}
                              >
                                <img
                                  style={{ height: '28px', width: '28px' }}
                                  src={editIcon}
                                  alt="Edit"
                                />
                              </button>

                              {(role === 'Admin' ||
                                role === 'super_admin' ||
                                userData?.accountType === 'Super User' ||
                                userData?.accountType === 'pmu' ||
                                userData?.accountType === 'super_admin' ||
                                userData?.accountType === 'Super Admin' ||
                                userData?.userType?.name === 'Super Admin' ||
                                userData?.userType?.name !== 'Funder') && (() => {
                                const clusterRow = cell?.row?.original
                                const count = traineeCounts[clusterRow?._id] || 0
                                const hasTrainees = count > 0

                                return (
                                  <button
                                    onClick={() =>
                                      handleOpenDeleteModal(clusterRow?._id, clusterRow)
                                    }
                                    title={
                                      hasTrainees
                                        ? `Cannot delete: ${count} trainee(s) assigned`
                                        : 'Delete Cluster'
                                    }
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                      cursor: hasTrainees ? 'not-allowed' : 'pointer',
                                      padding: 0,
                                      opacity: hasTrainees ? 0.35 : 1,
                                    }}
                                  >
                                    <img
                                      style={{
                                        height: '24px',
                                        width: '24px',
                                        filter: hasTrainees ? 'grayscale(100%)' : 'none',
                                      }}
                                      src={deleteIcon}
                                      alt="Delete"
                                    />
                                  </button>
                                )
                              })()}
                            </div>
                          )}
                        
                            <>
                        
                              {cell.column.Header === 'Number Of Trainee' ? (
                                <Styles.ActionSpan>
                                  <Link
                                    to={`/leads?filterbycluster=${cell.row.original._id}`}
                                  >
                                    {traineeCounts[cell.row.original._id] !== undefined
                                      ? traineeCounts[cell.row.original._id]
                                      : '-'}
                                  </Link>
                                </Styles.ActionSpan>
                              ) : (
                                cell.render('Cell')
                              )}
                            </>
                          
                        </Styles.TD>
                      )
                    })}
                  </Styles.TBodyRow>
                )
              })}
            </Styles.TBody>
          </Styles.Table>
        ) : (
          <h3>No projects to display</h3>
        )}
      </Styles.TableContainer>

      <Styles.PaginationmainContainer>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <span>
            <strong>
              Page {pageIndex + 1} of {pageOptions.length}
            </strong>
          </span>
          <select
            value={pageSize}
            onChange={e => {
              setPageSize(Number(e.target.value))
            }}
            style={{
              padding: '5px 10px',
              borderRadius: '4px',
              border: '1px solid #d9d9d9',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            {[5, 10, 25, 50, 100, 500, 1000, 2000, 3000, 5000].map(pageSizeOption => (
              <option key={pageSizeOption} value={pageSizeOption}>
                Show {pageSizeOption}
              </option>
            ))}
          </select>
        </div>
        <Styles.PaginationDiv>
          <Styles.PaginationButton
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
          >
            {'<<'}
          </Styles.PaginationButton>
          <Styles.PaginationButton
            onClick={previousPage}
            disabled={!canPreviousPage}
          >
            Previous
          </Styles.PaginationButton>
          <Styles.PaginationInputDiv>
            <input
              type="number"
              defaultValue={pageIndex + 1}
              onChange={e => {
                const pageNumber = e.target.value
                  ? Number(e.target.value) - 1
                  : 0
                gotoPage(pageNumber)
              }}
            />
          </Styles.PaginationInputDiv>
          <Styles.PaginationButton onClick={nextPage} disabled={!canNextPage}>
            Next
          </Styles.PaginationButton>
          <Styles.PaginationButton
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          >
            {'>>'}
          </Styles.PaginationButton>
        </Styles.PaginationDiv>
      </Styles.PaginationmainContainer>

      {openEditModal && (
        <EditProjectForm
          openEditModal={openEditModal}
          setOpenEditModal={setOpenEditModal}
          idToEdit={idToEdit}
          setIdToEdit={setIdToEdit}
          singleRow={singleRow}
          setSingleRow={setSingleRow}          
        />
      )}
      {openDeleteModal && (
        <DeleteModal
          idToDelete={idToDelete}
          clusterToDelete={clusterToDelete}
          traineeCount={traineeCounts[idToDelete] || 0}
          setDeleteModal={setDeleteModal}
        />
      )}
    </Styles.SupplierBox>
  )
}

export default Clusters
